import { render, staticRenderFns } from "./ItemAutocomplete.vue?vue&type=template&id=3db38a60&"
import script from "./ItemAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ItemAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VCheckbox,VChip})
